/**
 * variant-mode-controller.js
 *
 * variant:change 이벤트 감지 → window.__variantModes__ 조회 → DOM 업데이트
 *
 * 업데이트 대상:
 *   [data-buy-button]       — submit 버튼 래퍼 (show/hide)
 *   [data-submit-btn]       — 실제 submit 버튼 (텍스트/disabled)
 *   [data-inquire-btn]      — Inquire div 버튼 (show/hide)
 *   [data-inquire-text]     — Inquire 안내 텍스트 (show/hide, preorder↔inquire 전환 시)
 *   [data-preorder-message] — Pre-order 안내 문구 (show/hide, mode === 'preorder'일 때만 표시)
 */
(function () {
  'use strict';

  function applyMode(buybox, mode) {
    const buyButton  = buybox.querySelector('[data-buy-button]');
    const submitBtn  = buybox.querySelector('[data-submit-btn]');
    const inquireBtn = buybox.querySelector('[data-inquire-btn]');
    const preorderMsg = buybox.querySelector('[data-preorder-message]');

    // inquire-text 는 buybox 외부(product-info 레벨)에 있을 수 있으므로
    // 가장 가까운 product-info 컨테이너에서 탐색
    const infoWrap    = buybox.closest('.product-info') || document;
    const inquireText = infoWrap.querySelector('[data-inquire-text]');

    buybox.dataset.mode = mode;

    if (mode === 'inquire') {
      if (buyButton)   buyButton.style.display  = 'none';
      if (inquireBtn)  inquireBtn.style.display  = '';
      if (inquireText) inquireText.style.display = '';
      if (preorderMsg) preorderMsg.style.display = 'none';

    } else if (mode === 'preorder') {
      if (!submitBtn) return;
      if (buyButton)   buyButton.style.display  = '';
      if (inquireBtn)  inquireBtn.style.display  = 'none';
      if (inquireText) inquireText.style.display = 'none'; // preorder일 땐 텍스트 숨김
      if (preorderMsg) preorderMsg.style.display = '';
      submitBtn.disabled    = false;
      submitBtn.textContent = submitBtn.dataset.labelPreorder || '';

    } else if (mode === 'add_to_cart') {
      if (buyButton)   buyButton.style.display  = '';
      if (inquireBtn)  inquireBtn.style.display  = 'none';
      if (inquireText) inquireText.style.display = 'none';
      if (preorderMsg) preorderMsg.style.display = 'none';
      submitBtn.disabled    = false;
      submitBtn.textContent = submitBtn.dataset.labelAddToCart || '';

    } else if (mode === 'sold_out') {
      if (buyButton)   buyButton.style.display  = '';
      if (inquireBtn)  inquireBtn.style.display  = 'none';
      if (inquireText) inquireText.style.display = 'none';
      if (preorderMsg) preorderMsg.style.display = 'none';
      submitBtn.disabled    = true;
      submitBtn.textContent = submitBtn.dataset.labelSoldOut || '';

    } else if (mode === 'unavailable') {
      if (buyButton)   buyButton.style.display  = '';
      if (inquireBtn)  inquireBtn.style.display  = 'none';
      if (inquireText) inquireText.style.display = 'none';
      if (preorderMsg) preorderMsg.style.display = 'none';
      submitBtn.disabled    = true;
      submitBtn.textContent = submitBtn.dataset.labelUnavailable || '';
    }
  }

  function onVariantChange(event) {
    const variant = event.detail && event.detail.variant;
    if (!variant) return;

    const mode = (window.__variantModes__ || {})[String(variant.id)];
    if (!mode) return;

    // formId로 buybox 특정, 없으면 페이지 전체 업데이트
    let buyboxes = [];

    if (event.detail.formId) {
      const form = document.getElementById(event.detail.formId);
      if (form) {
        const bb = form.querySelector('[data-buybox]') || form.closest('[data-buybox]');
        if (bb) buyboxes = [bb];
      }
    }

    if (buyboxes.length === 0) {
      buyboxes = Array.from(document.querySelectorAll('[data-buybox]'));
    }

    buyboxes.forEach(bb => applyMode(bb, mode));
  }

  document.addEventListener('variant:change',  onVariantChange);
  document.addEventListener('variant:changed', onVariantChange); // fallback
})();